export default function Description() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2463] mb-6">
            O Que Você Vai Aprender
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Um guia completo e prático para transformar o comportamento do seu cão, desde os comandos básicos até técnicas avançadas de adestramento
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gradient-to-br from-[#0A2463] to-[#1E3A8A] rounded-3xl p-8 text-white shadow-xl">
            <div className="w-16 h-16 bg-[#FFB800] rounded-2xl flex items-center justify-center mb-6 overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/c7290d866904b78905fbd017988eccaa.jpeg" 
                alt="Fundamentos do Adestramento"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4">Fundamentos do Adestramento</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#FFB800] text-xl mt-1 flex-shrink-0"></i>
                <span>Como entender a linguagem corporal do seu cão</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#FFB800] text-xl mt-1 flex-shrink-0"></i>
                <span>Técnicas de reforço positivo / institívo&nbsp; comprovadas</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#FFB800] text-xl mt-1 flex-shrink-0"></i>
                <span>Estabelecendo liderança de forma respeitosa</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#FFB800] text-xl mt-1 flex-shrink-0"></i>
                <span>Criando rotinas eficazes de treinamento</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#FFB800] to-[#FFA500] rounded-3xl p-8 text-[#0A2463] shadow-xl">
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/467654583cd04cd8d6af09fa81e72f08.jpeg" 
                alt="Comandos Essenciais"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4">Comandos Essenciais</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#0A2463] text-xl mt-1 flex-shrink-0"></i>
                <span>Sentar, deitar, ficar e vir quando chamado</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#0A2463] text-xl mt-1 flex-shrink-0"></i>
                <span>Andar na coleira sem puxar</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#0A2463] text-xl mt-1 flex-shrink-0"></i>
                <span>Controle de latidos excessivos</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-[#0A2463] text-xl mt-1 flex-shrink-0"></i>
                <span>Socialização com outros cães e pessoas</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12 max-w-3xl mx-auto">
          <div className="bg-white border-2 border-[#0A2463] rounded-2xl p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 bg-[#0A2463] rounded-xl flex items-center justify-center mb-4 overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/c7290d866904b78905fbd017988eccaa.jpeg" 
                alt="Comandos Comportamentais"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <h4 className="text-xl font-bold text-[#0A2463] mb-3">Comandos Comportamentais</h4>
            <ul className="text-gray-600 space-y-2">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-[#0A2463] flex-shrink-0"></i>
                <span>Xixi no lugar certo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-[#0A2463] flex-shrink-0"></i>
                <span>Destruição de móveis</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-[#0A2463] flex-shrink-0"></i>
                <span>E muito mais</span>
              </li>
            </ul>
          </div>

          <div className="bg-white border-2 border-[#0A2463] rounded-2xl p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 bg-[#0A2463] rounded-xl flex items-center justify-center mb-4 overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/467654583cd04cd8d6af09fa81e72f08.jpeg" 
                alt="Correção de Problemas"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <h4 className="text-xl font-bold text-[#0A2463] mb-3">Correção de Problemas</h4>
            <ul className="text-gray-600 space-y-2">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-[#0A2463] flex-shrink-0"></i>
                <span>Agressividade</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-[#0A2463] flex-shrink-0"></i>
                <span>Medo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-[#0A2463] flex-shrink-0"></i>
                <span>Hiperatividade</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#0A2463] to-[#1E3A8A] rounded-3xl p-10">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center">
            &nbsp;Somos a Solução para seu Pet
          </h3>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <h4 className="text-2xl font-bold text-[#FFB800] mb-4">
                Seu Cão Não Obedece? Faz Bagunça em Casa? Puxa a Guia nos Passeios?
              </h4>
              <p className="text-white text-lg leading-relaxed">
                Nosso serviço de adestramento canino em São Paulo é fundamentado em técnicas modernas e reforço positivo, promovendo aprendizado com respeito e diversão para o seu melhor amigo.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <h4 className="text-2xl font-bold text-[#FFB800] mb-4">
                Se o comportamento do seu cão tem sido um desafio, não se preocupe!
              </h4>
              <p className="text-white text-lg leading-relaxed">
                Nós oferecemos o treinamento ideal para corrigir maus hábitos, fortalecer o vínculo entre tutor e pet e transformar seu cachorro em um companheiro equilibrado, educado e feliz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}